module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card is-large"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.generic && parseInt(_vm.context.$store.state.config.user.level) < 99),
      expression: "generic && parseInt(context.$store.state.config.user.level) < 99"
    }],
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.occurrence.typeOccurrence),
      expression: "occurrence.typeOccurrence"
    }],
    staticClass: "select is-fullwidth",
    attrs: {
      "name": "typeOccurrence",
      "id": "typeOccurrence"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.occurrence, "typeOccurrence", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.clearSubject()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Internal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("External")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.context.$store.state.config.user.level) < 99),
      expression: "parseInt(context.$store.state.config.user.level) < 99"
    }],
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.occurrence.type),
      expression: "occurrence.type"
    }],
    staticClass: "select is-fullwidth",
    attrs: {
      "name": "type",
      "id": "type"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.occurrence, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeType]
    }
  }, _vm._l((_vm.context.$store.state.config.occurrence.type), function(typeSelected) {
    return _c('option', {
      key: typeSelected.id,
      domProps: {
        "value": typeSelected.id
      }
    }, [_vm._v(_vm._s(typeSelected.name))])
  }), 0)])])]), _vm._v(" "), (parseInt(_vm.context.$store.state.config.user.level) < 99 && parseInt(_vm.occurrence.typeOccurrence) == 1) ? [_c('div', {
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Select Customer")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.customers,
      "placeholder": "Search a customer",
      "label": "name",
      "max-height": "200px"
    },
    on: {
      "search": _vm.getCustomers
    },
    model: {
      value: (_vm.occurrence.customer),
      callback: function($$v) {
        _vm.$set(_vm.occurrence, "customer", $$v)
      },
      expression: "occurrence.customer"
    }
  })], 1)])])] : _vm._e(), _vm._v(" "), ((parseInt(_vm.occurrence.type) == 1 && _vm.users && parseInt(_vm.context.$store.state.config.user.level) < 99) || (_vm.occurrence.customer && _vm.users && parseInt(_vm.context.$store.state.config.user.level) < 99)) ? _c('div', {
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("User")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.occurrence.user),
      expression: "occurrence.user"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'select': true,
      'is-fullwidth': true,
      'is-danger': _vm.errors.has('user')
    },
    attrs: {
      "name": "user",
      "id": "user"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.occurrence, "user", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.users), function(user) {
    return _c('option', {
      key: user.id,
      domProps: {
        "value": user
      }
    }, [_vm._v(_vm._s(user.name))])
  }), 0), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('user')),
      expression: "errors.has('user')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('user')))])])])]) : _vm._e(), _vm._v(" "), [_c('div', {
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Booking")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.occurrence.booking),
      expression: "occurrence.booking"
    }],
    class: {
      'input': true,
      'is-disabled': true
    },
    attrs: {
      "name": "booking",
      "id": "booking",
      "type": "text",
      "placeholder": "Booking"
    },
    domProps: {
      "value": (_vm.occurrence.booking)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.occurrence, "booking", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Service")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.occurrence.service),
      expression: "occurrence.service"
    }],
    class: {
      'input': true,
      'is-disabled': true
    },
    attrs: {
      "name": "service",
      "id": "service",
      "type": "text",
      "placeholder": "Service"
    },
    domProps: {
      "value": (_vm.occurrence.service)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.occurrence, "service", $event.target.value)
      }
    }
  })])])])], _vm._v(" "), (parseInt(_vm.context.$store.state.config.user.level) === 99) ? [_c('div', {
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Contact Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.occurrence.contactName),
      expression: "occurrence.contactName"
    }],
    class: {
      'input': true
    },
    attrs: {
      "name": "contact_name",
      "id": "contact_name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.occurrence.contactName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.occurrence, "contactName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Contact Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.occurrence.contactPhone),
      expression: "occurrence.contactPhone"
    }],
    class: {
      'input': true
    },
    attrs: {
      "name": "contact_phone",
      "id": "contact_phone",
      "type": "text"
    },
    domProps: {
      "value": (_vm.occurrence.contactPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.occurrence, "contactPhone", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Optional Users")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.optionalCustomerUsers,
      "placeholder": "Choose users to also receive notifications",
      "label": "name",
      "max-height": "200px",
      "name": "optionalCustomerUsers",
      "id": "optionalCustomerUsers",
      "multiple": ""
    },
    model: {
      value: (_vm.occurrence.optionalCustomerUsers),
      callback: function($$v) {
        _vm.$set(_vm.occurrence, "optionalCustomerUsers", $$v)
      },
      expression: "occurrence.optionalCustomerUsers"
    }
  })], 1)])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Subject")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.subjects,
      "placeholder": "Search a subject",
      "label": "subject",
      "max-height": "200px",
      "name": "subject",
      "id": "subject"
    },
    on: {
      "input": _vm.setSelectedSubject
    },
    model: {
      value: (_vm.subject),
      callback: function($$v) {
        _vm.subject = $$v
      },
      expression: "subject"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subjectError),
      expression: "subjectError"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Select a valid subject")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.context.$store.state.config.user.level) < 99 && parseInt(_vm.occurrence.type) === 2 && (_vm.subject && parseInt(_vm.subject.id) !== 14)),
      expression: "parseInt(context.$store.state.config.user.level) < 99 && parseInt(occurrence.type) === 2 && (subject && parseInt(subject.id) !== 14)"
    }],
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Department")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.department),
      expression: "department"
    }],
    staticClass: "select is-fullwidth",
    attrs: {
      "name": "department",
      "id": "department"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.department = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.context.$store.state.config.departaments), function(departament) {
    return (parseInt(departament.id) == 1 || parseInt(departament.id) == 2) ? _c('option', {
      domProps: {
        "value": departament.id
      }
    }, [_vm._v(_vm._s(departament.name) + " - " + _vm._s(departament.tips))]) : _vm._e()
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Ticket")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.occurrence.occurrence),
      expression: "occurrence.occurrence"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'textarea': true,
      'is-danger': _vm.errors.has('occurrence')
    },
    attrs: {
      "name": "occurrence",
      "id": "occurrence",
      "placeholder": "Explain how we can help you"
    },
    domProps: {
      "value": (_vm.occurrence.occurrence)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.occurrence, "occurrence", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('occurrence')),
      expression: "errors.has('occurrence')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('occurrence')))])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('vue-dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "dropzone",
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-queue-complete": _vm.vdSuccess,
      "vdropzone-sending": _vm.vdSendingEvent
    }
  })], 1)])], 2), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control is-pulled-right"
  }, [_c('a', {
    staticClass: "button is-primary",
    class: {
      'is-disabled': _vm.inProgress,
      'is-loading': _vm.inProgress
    },
    on: {
      "click": function($event) {
        return _vm.close(true)
      }
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('a', {
    class: {
      'button': true,
      'is-success': true,
      'is-disabled': _vm.errors.any() || _vm.inProgress,
      'is-loading': _vm.inProgress
    },
    on: {
      "click": function($event) {
        return _vm.openOccurrence()
      }
    }
  }, [_vm._v("Open")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d55e9a0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/occurrences/NewOccurrence.vue
// module id = 1096
// module chunks = 39